const envVars = {
  env: import.meta.env.VITE_NODE_ENV,

  screenDebug: JSON.parse(import.meta.env.VITE_CSS_SCREEN_DEBUGGER || 'false'),
  be: {
    isDev:
      `${import.meta.env.VITE_SERVER_URL}`.includes('dev') ||
      `${import.meta.env.VITE_SERVER_URL}`.includes('localhost'),

    apiUrl: `${import.meta.env.VITE_SERVER_URL}/api/`,

    devApiUrl: `${import.meta.env.VITE_DEV_SERVER_URL}/api/`,

    serverAsset: `${import.meta.env.VITE_SERVER_URL}/static/`,

    devGqlLink: `${import.meta.env.VITE_DEV_SERVER_URL}/graphql`,

    gqlLink: `${import.meta.env.VITE_SERVER_URL}/graphql`,

    subscriptionLink: import.meta.env.VITE_BACKEND_WS_URL,
  },
  aws: {
    s3Url: import.meta.env.VITE_AWS_S3_URL,
    bucket: import.meta.env.VITE_PROD_BUCKET,
    devBucket: import.meta.env.VITE_DEV_BUCKET,
  },
};

export { envVars };
